module.exports = __webpack_public_path__ + "static/img/romastersu_banner.534555a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/romastersu_banner.jpg
// module id = DQPm
// module chunks = 0